import { EXIT_DURATIONS } from '1_components/Transitition/settings';

export const ANIMATED_TEXT_ANIMATION = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
  transition: {
    duration: EXIT_DURATIONS.half,
    ease: 'easeInOut',
    delay: EXIT_DURATIONS.half,
  },
};
